import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-background py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-serif text-4xl font-semibold text-stone-900 mb-2">Privacy Policy</h1>
        <p className="text-muted-foreground mb-8 text-sm italic">Effective Date: 01-Mar-2026</p>
        
        <div className="prose prose-stone max-w-none space-y-8">
          <p className="text-stone-700 leading-relaxed">
            At SriSuktam Organics, we value your privacy and are committed to protecting your personal information. 
            This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website or purchase our products.
          </p>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">1. Information We Collect</h2>
            <div className="space-y-4">
              <div>
                <h3 className="font-medium text-stone-800">a) Personal Information</h3>
                <ul className="list-disc pl-5 text-stone-600 mt-2 space-y-1">
                  <li>Name</li>
                  <li>Email address</li>
                  <li>Phone number</li>
                  <li>Billing and shipping address</li>
                  <li>Payment details (processed securely via payment gateway)</li>
                </ul>
              </div>
              <div>
                <h3 className="font-medium text-stone-800">b) Non-Personal Information</h3>
                <ul className="list-disc pl-5 text-stone-600 mt-2 space-y-1">
                  <li>IP address</li>
                  <li>Browser type</li>
                  <li>Device information</li>
                  <li>Pages visited</li>
                  <li>Cookies and usage data</li>
                </ul>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">2. How We Use Your Information</h2>
            <ul className="list-disc pl-5 text-stone-600 space-y-2">
              <li>Process and deliver orders</li>
              <li>Communicate order updates</li>
              <li>Provide customer support</li>
              <li>Improve our website and services</li>
              <li>Send promotional offers (if opted in)</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">3. Payment Security</h2>
            <p className="text-stone-600">
              We do not store credit/debit card details. All payments are processed securely through trusted third-party payment gateways that comply with industry security standards.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">4. Cookies & Tracking Technologies</h2>
            <p className="text-stone-600 mb-2">Our website may use cookies to:</p>
            <ul className="list-disc pl-5 text-stone-600 space-y-1">
              <li>Improve user experience</li>
              <li>Remember login preferences</li>
              <li>Analyze website traffic</li>
            </ul>
            <p className="text-stone-600 mt-2">You can disable cookies in your browser settings.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">5. Sharing of Information</h2>
            <p className="text-stone-600 mb-2">We do not sell or rent your personal data. We may share information with:</p>
            <ul className="list-disc pl-5 text-stone-600 space-y-1">
              <li>Delivery partners</li>
              <li>Payment processors</li>
              <li>Legal authorities (if required by law)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">6. Data Protection</h2>
            <p className="text-stone-600">
              We implement reasonable security measures to protect your personal information. However, no online transmission is 100% secure.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">7. Your Rights</h2>
            <p className="text-stone-600 mb-2">You may:</p>
            <ul className="list-disc pl-5 text-stone-600 space-y-1">
              <li>Request access to your personal data</li>
              <li>Request correction or deletion</li>
              <li>Opt out of marketing communications</li>
            </ul>
            <p className="text-stone-600 mt-2">To exercise these rights, contact us at the email below.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">8. Third-Party Links</h2>
            <p className="text-stone-600">
              Our website may contain links to external sites. We are not responsible for their privacy practices.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">9. Children’s Privacy</h2>
            <p className="text-stone-600">
              Our products and services are not intended for children under 18 years of age.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">10. Changes to This Policy</h2>
            <p className="text-stone-600">
              We may update this Privacy Policy periodically. Updates will be posted on this page with a revised effective date.
            </p>
          </section>

          <section className="bg-muted p-6 rounded-2xl border border-stone-200">
            <h2 className="text-xl font-semibold text-stone-900 mb-2">11. Contact Us</h2>
            <p className="text-stone-700">If you have any questions about this Privacy Policy:</p>
            <div className="mt-4">
              <p className="font-semibold text-primary">SriSuktam Organics</p>
              <p className="text-stone-600">Email: <a href="mailto:srisuktamorganics@gmail.com" className="hover:underline">srisuktamorganics@gmail.com</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
